import { PatientInfo } from 'lib/api/firebase/apis/apis';
import moment, { Moment } from 'moment';
import { useState, useMemo, useCallback } from 'react';
type OutputType = PatientInfo &
  PatientInfo['__assessmentData__'] & {
    /**
     * The date the user record was added to the system
     */
    signUpDate: Moment;
    isPending?: boolean;
  };
export function useSearchQueryForPatientList(data: PatientInfo[]) {
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const [
    shouldOnlyShowCompletedAssessments,
    setShouldOnlyShowCompletedAssessments
  ] = useState<boolean>(false);

  const filteredData = useMemo<OutputType[]>(() => {
    let _data: OutputType[] = data as any;

    if (shouldOnlyShowCompletedAssessments) {
      // Only show patients that have a completed assessment
      _data = _data.filter(
        _ => _.__assessmentData__.lastCompletedAssessment !== null
      );
    }

    _data = _data.map(_ => ({
      ..._,
      key: _.id,
      lastCompletedAssessment: _.__assessmentData__.lastCompletedAssessment,
      recentAssessmentDate: _.__assessmentData__.recentAssessmentDate,
      signUpDate: moment(_.metadata?.created)
    }));

    /**
     * There is no search to filter by
     */
    if (searchQuery === null) return _data;
    return _data.filter(_ =>
      JSON.stringify({
        displayName: _.displayName,
        email: _.email,
        patientId: _.id
      })
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [data, searchQuery, shouldOnlyShowCompletedAssessments]);

  const updateSearchQuery = useCallback(
    (val: string | null) => setSearchQuery(val),
    []
  );

  const toggleCompletedAssessmentsOnly = useCallback(
    () => setShouldOnlyShowCompletedAssessments(val => !val),
    []
  );

  return {
    filteredData,
    updateSearchQuery,
    showCompletedAssessmentsOnly: shouldOnlyShowCompletedAssessments,
    toggleCompletedAssessmentsOnly
  };
}
